<template>
  <div class="app">
    <AppHeader fixed>
      <SidebarToggler
        class="d-lg-none"
        display="md"
        mobile
      />
      <b-link
        class="navbar-brand"
        to="#"
      >
        <div style="color: #fff;">
          {{ nombreSistema }}
        </div>
      </b-link>
      <SidebarToggler
        class="d-md-down-none"
        display="lg"
      />
      <b-navbar-nav class="d-md-down-none">
      </b-navbar-nav>
      <b-navbar-nav class="d-md-down-none ml-auto">
        <b-nav-item
          class="d-md-down-none"
          style="margin-right:15px;"
        >
          <DefaultHeaderDropdownNotif />
        </b-nav-item>
        <b-nav-item class="d-md-down-none">
          <DefaultHeaderDropdown />
        </b-nav-item>
      </b-navbar-nav>
      <AsideToggler class="d-none d-lg-block" />
    </AppHeader>
    <div class="app-body">
      <AppSidebar fixed>
        <SidebarHeader />
        <SidebarForm />
        <SidebarNav :navItems="navItems"></SidebarNav>
        <SidebarFooter />
        <SidebarMinimizer />
      </AppSidebar>
      <main class="main">
        <Breadcrumb :list="list" />
        <div class="container-fluid">
          <router-view></router-view>
        </div>
      </main>
      <AppAside fixed>
        <!--aside-->
        <DefaultAside />
      </AppAside>
    </div>
    <TheFooter>
      <!--footer-->
      <div>
        {{ nombreEmpresa }}
        <span class="ml-1">&copy; {{ año }}.</span>
      </div>
      <div class="ml-auto">
        <span class="mr-1">{{ nombreSistema }}</span>
      </div>
    </TheFooter>
  </div>
</template>

<script>
import nav from "@/_nav";
import {
  Header as AppHeader,
  SidebarToggler,
  Sidebar as AppSidebar,
  SidebarFooter,
  SidebarForm,
  SidebarHeader,
  SidebarMinimizer,
  SidebarNav,
  Aside as AppAside,
  AsideToggler,
  Footer as TheFooter,
  Breadcrumb
} from "@coreui/vue";
import DefaultAside from "./DefaultAside";
import DefaultHeaderDropdown from "./DefaultHeaderDropdown";
import DefaultHeaderDropdownNotif from "./DefaultHeaderDropdownNotif";

import { globalesMixin } from "@/components/mixins/globalesMixin";
import apiGlobales from "@/components/services/apiGlobales";

export default {
  name: "DefaultContainer",
  mixins: [globalesMixin],
  components: {
    AsideToggler,
    AppHeader,
    AppSidebar,
    AppAside,
    TheFooter,
    Breadcrumb,
    DefaultAside,
    DefaultHeaderDropdown,
    SidebarForm,
    SidebarFooter,
    SidebarToggler,
    SidebarHeader,
    SidebarNav,
    SidebarMinimizer,
    DefaultHeaderDropdownNotif
  },
  data() {
    return {
      modalTextoFinal: false,
      textoFinal: "",
      navItems: []
    };
  },
  methods: {
    // obtener menu
    obtenerMenu() {
      return apiGlobales
        .obtenerMenu(this.$session.get("mail"))
        .then(response => {
          response.data = this.keysMinuscula(response.data);
          this.crearMenu(response.data.res);
        });
    },

    // crear menu
    crearMenu(items) {
      var menu = [];
      var sistemas = [];
      // por cada item del menu
      for (var key in items) {
        // agregar sistema, solo si ya no existe
        if (
          !sistemas.find(sistema => sistema.idSistema == items[key].omusistema)
        ) {
          sistemas.push({
            idSistema: items[key].omusistema,
            nombre: items[key].sistitulo,
            url: items[key].sisurllogin
          });
        }
        // continuar solo si el item corresponde al sistema actual
        if (process.env.VUE_APP_ID_SISTEMA == items[key].omusistema) {
          // iniciar objeto de item
          var item = {};
          // asignar valores a item
          item.name = items[key].omudescripcion;
          item.url = items[key].omuurl;
          item.icon = items[key].omuicono;
          item.orden = items[key].omuorden;
          // si el item es de nivel 1
          if (items[key].omunivel == 1) {
            menu[items[key].omuopcion] = item;
          }
          // si el item es de nivel 2
          if (items[key].omunivel == 2) {
            // revisar si el item anterior tiene el key children, si no lo tiene, se crea
            if (menu[items[key].omupadre].children == undefined) {
              menu[items[key].omupadre].children = [];
            }
            // agregar el item al sub menu
            menu[items[key].omupadre]["children"][items[key].omuopcion] = item;
            // eleminar elementos vacios
            menu[items[key].omupadre]["children"] = menu[items[key].omupadre][
              "children"
            ].filter(function(el) {
              return el != null;
            });
            // ordenar items del menu
            menu[items[key].omupadre]["children"].sort(function(a, b) {
              return a.orden - b.orden;
            });
          }
        }
      }
      // eleminar elementos vacios
      menu = menu.filter(function(el) {
        return el != null;
      });
      // ordenar items del menu
      menu.sort(function(a, b) {
        return a.orden - b.orden;
      });
      this.navItems = menu;
      // setear estado
      this.$store.dispatch("setMenu", menu);
      this.$store.dispatch("setSistemas", sistemas);
    }
  },
  mounted() {
    this.obtenerMenu();
  },
  computed: {
    name() {
      return this.$route.name;
    },
    list() {
      return this.$route.matched.filter(
        route => route.name || route.meta.label
      );
    },
    nombreEmpresa() {
      return process.env.VUE_APP_EMPRESA;
    },
    año() {
      var today = new Date();
      return today.getFullYear();
    },
    nombreSistema() {
      return process.env.VUE_APP_NOMBRE_SISTEMA;
    }
  }
};
</script>

<style>
.navbar-nav .nav-link,
.navbar-nav .navbar .dropdown-toggle,
.navbar .navbar-nav .dropdown-toggle {
  color: #fff;
}

p {
  margin-bottom: 5px;
}
</style>
